import styles from './RightSidebarLayout.module.scss';

interface ComponentProps {
  children: React.ReactNode;
}

export const RightSidebarLayout = ({ children }: ComponentProps) => {
  return <main className={styles.mainmiddle}>{children}</main>;
};
